// 표지 한 면(A4)을 그리는 SVG 좌표계의 크기
export const PAGE_WIDTH_IN_PX = 620
export const PAGE_HEIGHT_IN_PX = 877

export const A4_WIDTH_IN_MM = 210
export const A4_HEIGHT_IN_MM = 297

export const PX_TO_MM_RATIO = A4_WIDTH_IN_MM / PAGE_WIDTH_IN_PX

// 인쇄소에서 받은 환산 비율이다
export const mmToPx2 = (mm: number) => (100 / 34) * mm
export const pxToMm2 = (px: number) => px * (34 / 100)
